/** Active drop-target override for `script_generation` semantic ports. */

export interface ActiveScriptDropTarget {
  sourceNodeId: string
  targetNodeId: string
  port: string
}

let activeScriptDropTarget: ActiveScriptDropTarget | null = null

export function setActiveScriptDropTarget(next: ActiveScriptDropTarget | null): void {
  activeScriptDropTarget = next
}

export function clearActiveScriptDropTarget(): void {
  activeScriptDropTarget = null
}

export function applyActiveScriptDropTargetOverride<
  T extends { source: string | null; target: string | null; targetHandle?: string | null },
>(connection: T, targetNodeType: string | null | undefined): { connection: T; overridden: boolean; port: string | null } {
  const active = activeScriptDropTarget
  if (
    !active ||
    targetNodeType !== 'script_generation' ||
    active.sourceNodeId !== connection.source ||
    active.targetNodeId !== connection.target
  ) {
    return { connection, overridden: false, port: null }
  }
  if (connection.targetHandle === active.port) {
    return { connection, overridden: false, port: active.port }
  }
  return { connection: { ...connection, targetHandle: active.port }, overridden: true, port: active.port }
}

export function dropMatchesCommittedScriptPort(
  highlightedPort: string | null,
  committedTargetHandle: string | null | undefined,
): boolean {
  if (!highlightedPort) return true
  if (!committedTargetHandle) return false
  if (highlightedPort === committedTargetHandle) return true
  return false
}
